import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import type { CreateSubscriptionResult } from '../types';

export function PaymentSection({
  subscription,
  onBack,
}: {
  subscription: CreateSubscriptionResult;
  onBack: () => void;
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!stripe || !elements) return;
    setSubmitting(true);
    setError(null);

    const confirmParams = {
      return_url: `${window.location.origin}${window.location.pathname}?view=success`,
    };

    const result =
      subscription.mode === 'setup'
        ? await stripe.confirmSetup({ elements, confirmParams })
        : await stripe.confirmPayment({ elements, confirmParams });

    // If we reach here, there was an immediate error (otherwise Stripe redirects).
    if (result.error) {
      setError(result.error.message ?? 'Payment could not be completed. Please try again.');
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement options={{ layout: 'tabs' }} />
      {error ? <div className="alert alert-error">{error}</div> : null}
      <button type="submit" className="btn btn-primary mt-16" disabled={!stripe || submitting}>
        {submitting ? 'Processing…' : `Subscribe — ${subscription.pricing.displayAmount}`}
      </button>
      <button type="button" className="btn btn-ghost" onClick={onBack} disabled={submitting}>
        Back
      </button>
      <div className="secure-note">🔒 Secured by Stripe</div>
    </form>
  );
}
